export default __webpack_public_path__ + "static/media/Tutor-landing-hero.ee0a67e2.png";